import {
    Modal,
} from 'components';
import { ActiveShipmentsContext, AuthContext, HomeContext } from 'contexts';
import { useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { EthereumForm } from '../components';
export const EthereumDocument = ({ open, onCancel }) => {
    const [listWallets, setListWallets] = useState([]);
    const { walletsFormat } = useContext(ActiveShipmentsContext);
    const [payload, setPayload] = useState({});
    const [walletsByOrgBackUp, setWalletByOrgBackUp] = useState([]);
    const { idDocumentSignature, setDocumentAwaitBlockChain, setAwaitDocuments, awaitDocuments, wallestByOrg } = useContext(HomeContext);
    const { doGenerateEthereum, shipmentDetails } = useContext(ActiveShipmentsContext);
    const { userInfo } = useContext(AuthContext);
    const { handleSubmit, register, errors } = useForm();

    /*eslint-disable */
    useEffect(() => {
        setListWallets(walletsFormat);
        setWalletByOrgBackUp(wallestByOrg);
        setPayload({...payload, partyAccount: {_id: wallestByOrg[0]?._id, address: wallestByOrg[0]?.address, value: wallestByOrg[0]?.value + ` (${wallestByOrg[0]?.address})`, orgId : wallestByOrg[0]?.orgId}})
    },[walletsFormat, wallestByOrg]);

    /*eslint-disable */


    const hanldSearchAccount = (value) => {
        setListWallets(walletsFormat?.filter(x => x?.value?.toLowerCase().includes(value?.toLowerCase())));
    }

    const handleSearchOwner = (value) => {
        setListWallets(walletsFormat?.filter(x => x?.value?.toLowerCase().includes(value?.toLowerCase())));
    }

    const handleSearchHolder = (value) => {
        setListWallets(walletsFormat?.filter(x => x?.value?.toLowerCase().includes(value?.toLowerCase())));
    }

    const handleSearchWalletByOrg = (value) => {
        setWalletByOrg(walletsByOrgBackUp?.filter(x => x?.value?.toLowerCase().includes(value?.toLowerCase())))
    }

    const handleComfirm = async () => {
        const orgId =  walletsFormat?.find(x => x.address.toLowerCase().includes(payload?.partyAccount?.address.toLowerCase()))?.orgId;
        const mainPayload = {};
        mainPayload.beneficiaryOrganizationId = payload?.ownerAccount?.address;
        mainPayload.holderOrganizationId = payload?.holderAccount?.address;
        mainPayload.organizationId = orgId;
        mainPayload.shipmentId = shipmentDetails?.permission?.shipmentId;
        mainPayload.walletPassword = payload?.password;
        mainPayload.userSubId = userInfo?.email;
        if (idDocumentSignature && mainPayload && orgId && payload) {
            doGenerateEthereum(idDocumentSignature, mainPayload, payload?.partyAccount?.address, 'Ethereum', shipmentDetails?.orgId, (data) => {
                if(data){
                    setAwaitDocuments([...awaitDocuments, {documentId: idDocumentSignature, status: true}]);
                    setDocumentAwaitBlockChain([{documentId: idDocumentSignature}]);
                    onCancel();
                }
            });
        }
    }



    return (
        <Modal
            open={open}
            onCancel={onCancel}
            title="Generate TT via Ethereum"
            submitButton={true}
            submitButtonLabel={"Generate "}
            isBackDropClickable={false}
            renderForm={children => (
                <form onSubmit={handleSubmit(handleComfirm)}>
                    {children}
                </form>
            )}
            isBackDropClickable={false}
        >
            <EthereumForm
                wallets={listWallets}
                walletByOrg={wallestByOrg}
                setWallets={setListWallets}
                setPayload={setPayload}
                payload={payload}
                hanldSearchAccount={hanldSearchAccount}
                handleSearchOwner={handleSearchOwner}
                handleSearchHolder={handleSearchHolder}
                walletsBackUp={listWallets}
                walletsByOrgBackUp={walletsByOrgBackUp}
                setWalletByOrgBackUp={setWalletByOrgBackUp}
                handleSearchWalletByOrg={handleSearchWalletByOrg}
                register={register}
                errors={errors}
            />
        </Modal>
    )
}
